import { TweenMax,TimelineMax, Sine,Linear} from "gsap";
import { Tween } from "jquery";
//  Power2, Elastic, CSSPlugin ,Tweenmax
export function play(){
  var tl = new TimelineMax()
  // TweenMax.set(".f94ab088-8e2a-4a5a-8870-8964a1154232:nth-child(2n)",{
  //   css: {
  //     display: 'none'
  //   }
  // })
  tl.set(`[data-name="biker"]`,{
    x: -130,
    y: -80,
    // opacity: 0
  })
  // tl.to(`[data-name="biker"]`,1,{
  //   opacity: 1

  // })
  tl.to(`[data-name="biker"]`,10,{
    y: 80,
    x: 70,
    rotate: -10,
    ease: Sine.easeInOut,
  })

  TweenMax.to(`[data-name="vehicle_bus"]`,5,{
    x: 20,
    y: 10,
    // rotate: -10,
    ease: Sine.easeInOut,
  }).repeat(-1).yoyo(true)
  

  TweenMax.to(`[data-name="vehicle_motorbike"]`,1,{
    y: 5,
  }).repeat(-1).yoyo(true)
  TweenMax.to(`[data-name="vehicle_motorbike"] rect:nth-child(5n+4)`,2,{
    fill: "#ffebb5"
  }).repeat(-1).yoyo(true)
  // tl.to(`[data-name="biker"]`,1,{
  //   y: 160,
  //   x: 150,
  //   opacity: 0,
  //   ease: Sine.easeIn,

  // })
  tl.repeat(-1).yoyo(true)

  
  TweenMax.staggerTo(`[data-name="buildings_頁面"] `,4,{
    y: -30,
    ease: Sine.easeInOut
  },1).repeat(-1).yoyo(true)
  TweenMax.staggerFrom(`[data-name="buildings_頁面"] line, [data-name="buildings_頁面"] polygon `,0.7,{
    opacity: 0
  },0.2).repeat(-1)
  TweenMax.set(`[data-name="buildings_頁面"] polyline`,{
    css: {
      "stroke-dasharray": 100,
    }
  })
  TweenMax.from(`[data-name="buildings_頁面"] polyline`,5,{
    css: {
      "stroke-dashoffset": 300
    }
  }).repeat(-1).yoyo(true)

  //機車輪子
  // let motorWheel = `path.a6846ad4-a7ea-40ae-add3-98881f2f4790`
  // TweenMax.set(motorWheel,{
  //   css: {
  //     "stroke-dasharray": 50,
  //     "stroke-dashoffset": -50
  //   }
  // })
  // TweenMax.staggerFrom(motorWheel,2,{
  //   css: {
  //     "stroke-dashoffset": 50
  //   }
  // },0.1).repeat(-1)
  

  TweenMax.from(`[data-name="floor_line_bike"]`,0.5,{
    css: {
      "stroke-dashoffset": -39
    },
    ease: Linear.easeNone
    
  },0.1).repeat(-1)
  TweenMax.from(`[data-name="floor_line_bus"]`,1.5,{
    css: {
      "stroke-dashoffset": -39
    },
    ease: Linear.easeNone
    
  },0.1).repeat(-1)

  TweenMax.set(`[data-name="woman"]`,{
    transformOrigin:"50% 100%"
  })
  TweenMax.to(`[data-name="woman"]`,2,{
    y: 2,
    rotate: 2
  }).repeat(-1).yoyo(true)

  TweenMax.set(`[data-name="woman_hand"]`,{
    transformOrigin:"0% 0%"
  })
  TweenMax.to(`[data-name="woman_hand"]`,2,{
    y: 2,
    rotate: -20
  }).repeat(-1).yoyo(true)

  // Youbike
  TweenMax.to(`[data-name="other_bike"] path:nth-child(-n+5)`,1.5,{
    x: 10,
    y: -16,
    ease: Linear.easeOut
  }).repeat(-1).yoyo(true)

}